@if ({isAuthenticated: isAuthenticated$ | async}; as model) {
  <div
    class="apply-one-style"
    role="navigation"
    aria-label="Navigation Espace Client"
    >
    @if (!model.isAuthenticated && !isEclair) {
      <ecm-visitor-header></ecm-visitor-header>
    }
    @if ((model.isAuthenticated || isEclair) && isSoshMenu) {
      <ecm-sosh-menu></ecm-sosh-menu>
    }
    @if ((model.isAuthenticated || isEclair) && !isSoshMenu) {
      <ecm-orange-menu></ecm-orange-menu>
    }
  </div>
}
